module.exports = __webpack_public_path__ + "static/media/2.0e5d37d5.svg";